import React from 'react';
import { Icon } from './Icon.js';
export const IconEarphones = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 10V21H18V13L22 12V5H19C16.2386 5 14 7.23858 14 10Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 8V19H6V11L2 10V3H5C7.76142 3 10 5.23858 10 8Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconEarphones.js.map